/**
 * All site texts organized by dot-notation keys.
 * Each key maps to { bg, en, de } translations.
 * 
 * To edit any text on the site, simply change the values here.
 */
export const siteTexts = {
  "confirmation.attendance.no": {
    "en": "No",
    "bg": "Не",
    "de": "Nein"
  },
  "confirmation.attendance.notSure": {
    "bg": "Все още не съм сигурен",
    "en": "Not sure yet",
    "de": "Noch nicht sicher"
  },
  "confirmation.attendance.question": {
    "de": "Feiern wir zusammen?",
    "en": "Shall we celebrate together?",
    "bg": "Ще празнуваме ли заедно?"
  },
  "confirmation.attendance.title": {
    "de": "Teilnahmestatus",
    "bg": "Статус на присъствие",
    "en": "Attendance status"
  },
  "confirmation.attendance.yes": {
    "de": "Ja",
    "en": "Yes",
    "bg": "Да"
  },
  "confirmation.guests.childAge": {
    "en": "Child {{number}} age",
    "bg": "Възраст на дете {{number}}",
    "de": "Alter des Kindes {{number}}"
  },
  "confirmation.guests.children": {
    "de": "Bringst du Kinder mit?",
    "bg": "Ще доведеш ли деца?",
    "en": "Will you bring kids?"
  },
  "confirmation.guests.childrenCount": {
    "de": "Wie viele Kinder?",
    "bg": "Колко деца?",
    "en": "How many kids?"
  },
  "confirmation.guests.no": {
    "en": "No",
    "bg": "Не",
    "de": "Nein"
  },
  "confirmation.guests.plusOne": {
    "de": "Kommst mit Begleitung?",
    "bg": "Ще доведете ли +1?",
    "en": "Will you bring a +1?"
  },
  "confirmation.guests.plusOneCount": {
    "bg": "Колко души?",
    "en": "How many people?",
    "de": "Wie viele Personen?"
  },
  "confirmation.guests.title": {
    "de": "Kommt noch jemand mit dir?",
    "en": "Anyone else joining you?",
    "bg": "Идва ли още някой с теб?"
  },
  "confirmation.guests.yes": {
    "bg": "Да",
    "en": "Yes",
    "de": "Ja"
  },
  "confirmation.home": {
    "bg": "Начало",
    "en": "Home",
    "de": "Startseite"
  },
  "confirmation.modal.addToCalendar": {
    "bg": "Добави в Google Calendar",
    "en": "Add to Google Calendar",
    "de": "Zu Google Kalender hinzufügen"
  },
  "confirmation.modal.calendarPrompt": {
    "de": "Möchten Sie die Hochzeit zu Ihrem Kalender hinzufügen?",
    "en": "Would you like to add the wedding to your calendar?",
    "bg": "Искате ли да добавите сватбата в календара си?"
  },
  "confirmation.modal.close": {
    "de": "Schließen",
    "bg": "Затвори",
    "en": "Close"
  },
  "confirmation.modal.message": {
    "de": "Ihre Bestätigung wurde empfangen.",
    "en": "Your confirmation has been received.",
    "bg": "Вашето потвърждение е получено."
  },
  "confirmation.modal.title": {
    "en": "Thank You!",
    "bg": "Благодарим Ви!",
    "de": "Vielen Dank!"
  },
  "confirmation.personalInfo.both": {
    "de": "Beide",
    "en": "Both",
    "bg": "И двете"
  },
  "confirmation.personalInfo.bride": {
    "bg": "Булка",
    "en": "Bride",
    "de": "Braut"
  },
  "confirmation.personalInfo.email": {
    "de": "E-Mail-Adresse",
    "bg": "Имейл адрес",
    "en": "Email address"
  },
  "confirmation.personalInfo.groom": {
    "en": "Groom",
    "bg": "Младоженец",
    "de": "Bräutigam"
  },
  "confirmation.personalInfo.invitationSide": {
    "de": "Zu welcher Seite gehörst du?",
    "en": "Which side are you on?",
    "bg": "От коя страна си?"
  },
  "confirmation.personalInfo.name": {
    "bg": "Име и фамилия",
    "en": "First and last name",
    "de": "Vor- und Nachname"
  },
  "confirmation.personalInfo.phone": {
    "en": "Phone number",
    "bg": "Телефонен номер",
    "de": "Telefonnummer"
  },
  "confirmation.personalInfo.title": {
    "de": "Ein bisschen über dich",
    "bg": "Малко за теб",
    "en": "About you"
  },
  "confirmation.requirements.placeholder": {
    "bg": "Хранителни ограничения, коментари, бележки и други",
    "en": "Dietary restrictions, comments, notes and others",
    "de": "Ernährungseinschränkungen, Kommentare, Notizen und anderes"
  },
  "confirmation.requirements.title": {
    "de": "Gibt es etwas, das wir wissen sollten?",
    "en": "Anything we should know?",
    "bg": "Има ли нещо, което трябва да знаем?"
  },
  "confirmation.sending": {
    "en": "Sending...",
    "bg": "Изпращане...",
    "de": "Wird gesendet..."
  },
  "confirmation.submit": {
    "en": "Send",
    "bg": "Изпрати",
    "de": "Senden"
  },
  "confirmation.title": {
    "de": "Hochzeitsbestätigung",
    "bg": "Потвърждение за сватба",
    "en": "Wedding confirmation"
  },
  "footer.ceremony": {
    "bg": "Церемония:",
    "en": "Ceremony:",
    "de": "Zeremonie:"
  },
  "footer.ceremonyLocation": {
    "bg": "Параклис Agios Vasilios",
    "en": "Agios Vasilios Chapel",
    "de": "Kapelle Agios Vasilios"
  },
  "footer.dinner": {
    "bg": "Вечеря:",
    "en": "Dinner:",
    "de": "Abendessen:"
  },
  "footer.dinnerLocation": {
    "bg": "Таверна Axivadaki",
    "en": "Axivadaki tavern",
    "de": "Axivadaki Taverne"
  },
  "footer.confirmation": {
    "bg": "Потвърждение",
    "en": "Confirmation",
    "de": "Bestätigung"
  },
  "footer.copyright": {
    "bg": "© 2026 Сватбата на Надя и Петър",
    "en": "© 2026 Nadya & Petar's Wedding",
    "de": "© 2026 Hochzeit von Nadya & Petar"
  },
  "footer.date": {
    "bg": "5-7 юни 2026 • Гърция",
    "en": "June 5–7, 2026 • Greece",
    "de": "5.–7. Juni 2026 • Griechenland"
  },
  "footer.hotels": {
    "de": "Hotels:",
    "en": "Hotels:",
    "bg": "Хотели:"
  },
  "footer.names": {
    "bg": "Надя и Петър",
    "en": "Nadya & Petar",
    "de": "Nadya & Petar"
  },

  "footer.tagline": {
    "bg": "Празнуваме любовта, семейството и моментите, които ни обединяват.",
    "en": "Celebrating love, family, and the moments that bring us together.",
    "de": "Wir feiern Liebe, Familie und die Momente, die uns zusammenbringen."
  },
  "gallery.subtitle": {
    "bg": "След сватбата всеки ще може да качва и разглежда снимки тук.",
    "en": "After the wedding, everyone will be able to upload and view photos here.",
    "de": "Nach der Hochzeit kann jeder hier Fotos hochladen und ansehen."
  },
  "gallery.subtitle2": {
    "bg": "Бихме искали да видим спомените, които сте заснели!",
    "en": "We'd love to see the memories you captured!",
    "de": "Wir würden uns freuen, die Erinnerungen zu sehen, die Sie festgehalten haben!"
  },
  "gallery.title": {
    "de": "Galerie",
    "en": "Gallery",
    "bg": "Галерия"
  },
  "gallery.uploadButton": {
    "de": "Laden Sie Ihre Fotos hoch",
    "en": "Upload your photos",
    "bg": "Качете вашите снимки"
  },
  "galleryPage.bulkDeleteConfirm": {
    "en": "Are you sure you want to delete these {{count}} photos? This cannot be undone.",
    "bg": "Сигурни ли сте, че искате да изтриете тези {{count}} снимки? Това не може да бъде отменено.",
    "de": "Sind Sie sicher, dass Sie diese {{count}} Fotos löschen möchten? Dies kann nicht rückgängig gemacht werden."
  },
  "galleryPage.bulkDeleteFailed": {
    "de": "Einige Fotos konnten nicht gelöscht werden.",
    "en": "Failed to delete some photos.",
    "bg": "Неуспешно изтриване на някои снимки."
  },
  "galleryPage.cancel": {
    "de": "Abbrechen",
    "en": "Cancel",
    "bg": "Отказ"
  },
  "galleryPage.deleteConfirm": {
    "bg": "Сигурни ли сте, че искате да изтриете тази снимка? Това не може да бъде отменено.",
    "en": "Are you sure you want to delete this photo? This cannot be undone.",
    "de": "Sind Sie sicher, dass Sie dieses Foto löschen möchten? Dies kann nicht rückgängig gemacht werden."
  },
  "galleryPage.deleteFailed": {
    "en": "Failed to delete photo.",
    "bg": "Неуспешно изтриване на снимка.",
    "de": "Foto konnte nicht gelöscht werden."
  },
  "galleryPage.deleteSelected": {
    "de": "Ausgewählte löschen",
    "en": "Delete Selected",
    "bg": "Изтрий избраните"
  },
  "galleryPage.home": {
    "bg": "Начало",
    "en": "Home",
    "de": "Startseite"
  },
  "galleryPage.noImages": {
    "en": "No uploaded images yet.",
    "bg": "Все още няма качени снимки.",
    "de": "Noch keine hochgeladenen Bilder."
  },
  "galleryPage.seePhotos": {
    "en": "See photos",
    "bg": "Вижте снимки",
    "de": "Fotos ansehen"
  },
  "galleryPage.selected": {
    "en": "selected",
    "bg": "избрани",
    "de": "ausgewählt"
  },
  "galleryPage.subtitle": {
    "en": "See the pictures from the wedding here",
    "bg": "Вижте снимките от сватбата тук",
    "de": "Sehen Sie hier die Bilder von der Hochzeit"
  },
  "galleryPage.title": {
    "bg": "Галерия",
    "en": "Gallery",
    "de": "Galerie"
  },
  "galleryPage.uploadYourOwn": {
    "de": "Bilder hochladen",
    "en": "Share your photos",
    "bg": "Споделете снимки"
  },
  "hero.alt": {
    "bg": "Сватбена снимка",
    "en": "Wedding Hero",
    "de": "Hochzeits-Hero"
  },
  "info.close": {
    "en": "Close",
    "bg": "Затвори",
    "de": "Schließen"
  },
  "info.foundationButton": {
    "de": "Stiftungs-Website besuchen",
    "en": "Visit Foundation Website",
    "bg": "Посетете сайта на фондацията"
  },
  "info.mapButton": {
    "en": "See more",
    "bg": "Виж повече",
    "de": "Mehr anzeigen"
  },
  "info.mapButtonPiraeus": {
    "en": "View Piraeus Port on Google Maps",
    "bg": "Виж пристанище Пиреус в Google Maps",
    "de": "Hafen von Piräus auf Google Maps anzeigen"
  },
  "info.mapButtonSchedule": {
    "en": "View on Google Maps",
    "bg": "Виж в Google Maps",
    "de": "Auf Google Maps ansehen"
  },
  "info.notAnnouncedYet": {
    "de": "Noch nicht veröffentlicht",
    "bg": "Още не е публикувано",
    "en": "Not published yet"
  },
  "info.title": {
    "de": "Wichtige Informationen",
    "bg": "Важна информация",
    "en": "Important information"
  },
  "info.travelHelp": {
    "en": "If anyone needs help with booking travel or accommodation, please reach out to Irina—she is a family friend who runs a travel agency, and she will be happy to help you.",
    "bg": "Ако някой има нужда от помощ с резервациите за пътуване или настаняване, моля свържете се с Ирина – тя е семейна приятелка, която има туристическа агенция, и ще се радва да ви помогне.",
    "de": "Falls jemand Hilfe bei der Buchung von Reise oder Unterkunft benötigt, wendet euch bitte an Irina – sie ist eine Freundin der Familie, die ein Reisebüro leitet, und hilft euch gerne weiter."
  },
  "info.travelHelpPhone": {
    "en": "Call Irina here +359 89 540 4889",
    "bg": "Обадете се на Ирина тук +359 89 540 4889",
    "de": "Irina hier anrufen +359 89 540 4889"
  },
  "invitation.headline1": {
    "en": "We searched for each other for a long time..",
    "bg": "Търсихме се дълго.. намерихме се..",
    "de": "Wir haben lange nacheinander gesucht.."
  },
  "invitation.headline2": {
    "en": "and we found one another.. Now we want to celebrate this",
    "bg": "искаме да го отпразнуваме с хората",
    "de": "und wir haben uns gefunden.. Jetzt möchten wir das"
  },
  "invitation.headline3": {
    "de": "mit den Menschen feiern, die irgendwo auf dem Weg unser Leben berührt haben..",
    "bg": "които са докоснали живота ни някъде по пътя..",
    "en": "with the people who have touched our lives somewhere along the way.."
  },
  "invitation.text1": {
    "en": "We're doing it between June 5th and 7th on the island of Aegina, near Athens.",
    "bg": "Планираме това да се случи между 5-7 юни някъде, на остров Егина близо до Атина..",
    "de": "Wir machen es zwischen dem 5. und dem 7. Juni auf der Insel Aegina, in der Nähe von Athen."
  },
  "invitation.text3": {
    "de": "Bitte save the date schon mal… Details folgen :)",
    "en": "Please save the date… more details to follow :)",
    "bg": "Запазете датите засега.. подробностите идват :)"
  },
  "location.address": {
    "de": "...",
    "en": "...",
    "bg": "..."
  },
  "location.mapButton": {
    "en": "See location on Google Maps",
    "bg": "Вижте локацията в Google Maps",
    "de": "Standort auf Google Maps anzeigen"
  },
  "location.notAnnouncedYet": {
    "en": "Location has not been announced yet",
    "bg": "Локацията все още не е обявена",
    "de": "Der Standort wurde noch nicht bekannt gegeben"
  },
  "location.title": {
    "de": "Standorte",
    "bg": "Локации",
    "en": "Locations"
  },
  "location.venue": {
    "bg": "123124",
    "en": "TBA",
    "de": "TBA"
  },
  "nav.confirmation": {
    "bg": "Потвърждение",
    "en": "Confirmation",
    "de": "Bestätigung"
  },
  "nav.home": {
    "en": "Home",
    "bg": "Начало",
    "de": "Startseite"
  },
  "schedule.title": {
    "de": "Die Hochzeit - 6.06.26",
    "en": "The Wedding Day - 6.06.26",
    "bg": "Сватбеният ден - 6.06.26"
  },
  "validation.attendanceRequired": {
    "bg": "Моля, изберете статус на присъствие",
    "en": "Please select your attendance status",
    "de": "Bitte wählen Sie Ihren Teilnahmestatus aus"
  },
  "validation.childAgeInvalid": {
    "de": "Bitte geben Sie ein gültiges Alter ein (nur Zahlen)",
    "bg": "Моля, въведете валидна възраст (само цифри)",
    "en": "Please enter a valid age (numbers only)"
  },
  "validation.childAgeRange": {
    "en": "Age must be between 0 and 18",
    "bg": "Възрастта трябва да бъде между 0 и 18",
    "de": "Das Alter muss zwischen 0 und 18 liegen"
  },
  "validation.childAgeRequired": {
    "de": "Bitte geben Sie das Alter des Kindes ein",
    "bg": "Моля, въведете възрастта на детето",
    "en": "Please enter the child's age"
  },
  "validation.childrenRequired": {
    "de": "Bitte geben Sie an, ob Sie Kinder mitbringen",
    "bg": "Моля, посочете дали ще доведете деца",
    "en": "Please indicate if you will bring children"
  },
  "validation.emailInvalid": {
    "de": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "en": "Please enter a valid email address",
    "bg": "Моля, въведете валиден имейл адрес"
  },
  "validation.emailRequired": {
    "bg": "Моля, въведете вашия имейл адрес",
    "en": "Please enter your email address",
    "de": "Bitte geben Sie Ihre E-Mail-Adresse ein"
  },
  "validation.invitationSideRequired": {
    "bg": "Моля, изберете страна на поканата",
    "en": "Please select the side of invitation",
    "de": "Bitte wählen Sie die Seite der Einladung aus"
  },
  "validation.nameInvalid": {
    "bg": "Името може да съдържа само букви, интервали и тирета",
    "en": "Name can only contain letters, spaces, and hyphens",
    "de": "Der Name darf nur Buchstaben, Leerzeichen und Bindestriche enthalten"
  },
  "validation.nameRequired": {
    "bg": "Моля, въведете вашето име",
    "en": "Please enter your name",
    "de": "Bitte geben Sie Ihren Namen ein"
  },
  "validation.nameTooShort": {
    "bg": "Името трябва да бъде поне 2 символа",
    "en": "Name must be at least 2 characters",
    "de": "Der Name muss mindestens 2 Zeichen lang sein"
  },
  "validation.phoneInvalid": {
    "de": "Die Telefonnummer darf nur Zahlen, Leerzeichen, +, - und () enthalten",
    "bg": "Телефонният номер може да съдържа само цифри, интервали, +, -, и ()",
    "en": "Phone number can only contain numbers, spaces, +, -, and ()"
  },
  "validation.phoneRequired": {
    "en": "Please enter your phone number",
    "bg": "Моля, въведете вашия телефонен номер",
    "de": "Bitte geben Sie Ihre Telefonnummer ein"
  },
  "validation.phoneTooShort": {
    "bg": "Телефонният номер е твърде кратък",
    "en": "Phone number is too short",
    "de": "Die Telefonnummer ist zu kurz"
  },
  "validation.plusOneCountInvalid": {
    "en": "Please enter a valid number",
    "bg": "Моля, въведете валидно число",
    "de": "Bitte geben Sie eine gültige Anzahl ein"
  },
  "validation.plusOneCountRange": {
    "en": "Number of guests must be between 1 and 10",
    "bg": "Броят гости трябва да бъде между 1 и 10",
    "de": "Die Anzahl der Gäste muss zwischen 1 und 10 liegen"
  },
  "validation.plusOneCountRequired": {
    "bg": "Моля, въведете броя на допълнителните гости",
    "en": "Please enter the number of additional guests",
    "de": "Bitte geben Sie die Anzahl der zusätzlichen Gäste ein"
  },
  "validation.plusOneRequired": {
    "de": "Bitte geben Sie an, ob Sie eine Begleitung mitbringen",
    "en": "Please indicate if you will bring a +1",
    "bg": "Моля, посочете дали ще доведете +1"
  },
  "validation.requirementsInvalid": {
    "bg": "Открити са невалидни символи в специалните изисквания",
    "en": "Invalid characters detected in special requirements",
    "de": "Ungültige Zeichen in besonderen Anforderungen erkannt"
  },
  "validation.requirementsRequired": {
    "en": "Please enter any special requirements or write 'None'",
    "bg": "Моля, въведете специални изисквания или напишете 'Няма'",
    "de": "Bitte geben Sie besondere Anforderungen ein oder schreiben Sie 'Keine'"
  }
};
